'use strict'

import { PartialsEvents } from 'assets/core/js/module/partialsManager'
import SelectManager from 'assets/core/js/module/selectManager'
import { Facets } from 'assets/themes/vacances-campings/js/page/product/facets'
import { AccommodationsData, AccommodationsOrder } from 'assets/core/js/types/globals'
import CheckoutAccess from '@ui/Accommodation/CheckoutAccess/component'

export default function (facets: Facets): void {
  document.querySelector<HTMLElement>('[data-partial-id="results"]')?.addEventListener(PartialsEvents.POST_UPDATE, (e) => {
    const target = e.target as HTMLElement
    const detail = (e as CustomEvent).detail as {
      data: {
        accommodationsData: AccommodationsData
        accommodationsOrder: AccommodationsOrder
      }
    }

    if (detail && detail.data) {
      window.accommodationsData = detail.data.accommodationsData
      window.accommodationsOrder = detail.data.accommodationsOrder
    }
    facets.sortAccommodations()

    const checkOfferForms = target.querySelectorAll<HTMLFormElement>('form[data-check-offer-id]')
    checkOfferForms.forEach((checkOfferForm) => {
      CheckoutAccess(checkOfferForm)

      checkOfferForm.addEventListener('submit', function (e) {
        document.body.dispatchEvent(
          new CustomEvent('checkOfferForm.submit', {
            detail: { accommodationId: (e.target as HTMLElement).closest('.result')?.getAttribute('data-id') as string },
          })
        )
      })
    })
  })

  document.querySelector('[data-partial-id="searchForm"]')?.addEventListener(PartialsEvents.POST_UPDATE, (e) => {
    const detail = (e as CustomEvent).detail as {
      data: { [key: string]: { choices: Record<string, string>; value: string } }
    }

    if (detail && detail.data) {
      for (const key in detail.data) {
        const data = detail.data[key]

        if (!data) {
          return
        }

        SelectManager.clear(key)
        SelectManager.setValues(key, data)
          .then(() => true)
          .catch(() => true)
      }
    }
  })
}
